<template>
  <Teleport to="#dialog">
    <transition appear name="fade">
      <div id="menu-detail-in-dialog" class="detail-wrap" v-if="visible">
        <div class="detail-content">
          <div class="detail-button">
            <menu-detail></menu-detail>
          </div>
          <div class="detail-quantity">
            <quantity></quantity>
          </div>
          <div style="padding: 5px 15px 15px">
            <menu-button :isInView="true" @closeDetail="closeDetail"></menu-button>
          </div>
        </div>
      </div>
    </transition>
  </Teleport>
</template>
<script>
import { inject, defineAsyncComponent } from 'vue';
import { useActions } from '@/utils/mapStore';
export default {
  name: 'menu-detail-in-dialog',
  components: {
    MenuDetail: defineAsyncComponent(() => import('@/components/order/right/menu/MenuDetail.vue')),
    MenuButton: defineAsyncComponent(() => import('@/components/order/right/button/MenuButton.vue')),
    Quantity: defineAsyncComponent(() => import('@/components/order/right/menu/Quantity.vue')),
  },
  setup() {
    const visible = inject('inner_dialogVisible', false);
    const close = inject('inner_close');
    //返回
    const doCancelItem = useActions('menuItem', ['doCancelItem']);
    const closeDetail = () => {
      doCancelItem();
      close();
    };
    return {
      visible,
      closeDetail,
    };
  },
};
</script>
<style lang="scss" scoped>
.detail {
  &-wrap {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    background-color: $color-mask;
    @include flex-center-center;
    z-index: 900;
  }
  &-content {
    width: 780px;
    height: 95vh;
    max-height: 850px;
    display: grid;
    grid-template-rows: auto minmax(50px, 7%) 140px;
    @include white-bg;
  }
  &-quantity {
    padding: 0 15px;
  }
}
</style>
